import { language } from "@chef/constants";

export const intl = (
  {
    dk: {
      ADD_GROCERIES: "Tilføj specialvarer",
      WILL_BE_ADDED_TO_YOUR_SUBSCRIPTION: "",

      SEARCH: "Søk",

      COULD_NOT_FIND_ANY: "Fant ingen produkter",

      TOTAL: "I alt",
      CONTINUE_BUTTON: "Næste",
    },

    no: {
      ADD_GROCERIES: "Legg til dagligvarer",
      WILL_BE_ADDED_TO_YOUR_SUBSCRIPTION: "Legges til i ditt abonnement.",

      SEARCH: "Søk",

      COULD_NOT_FIND_ANY: "Fant ingen produkter",

      TOTAL: "Totalt",
      CONTINUE_BUTTON: "Gå videre",
    },

    se: {
      ADD_GROCERIES: "Lägg till livsmedel",
      WILL_BE_ADDED_TO_YOUR_SUBSCRIPTION: "Läggs till i din prenumeration.",

      SEARCH: "Sök",

      COULD_NOT_FIND_ANY: "Hittade inga produkter",

      TOTAL: "Totalt",
      CONTINUE_BUTTON: "Gå vidare",
    },
  } as const
)[language];
